// extracted by mini-css-extract-plugin
module.exports = {"loader__container":"style_loader__container__2K20t","loader":"style_loader__1_KIE","rotation":"style_rotation__2T4_n"};